import type { AgendaOS } from '@/services/agenda.service';

const STATUS_VISIVEIS = ['aceita', 'em_execucao', 'concluida'] as const;

/**
 * OS que entram no calendário do prestador: atribuídas a ele, com data agendada,
 * nos estados ativos/concluído. Exclui as de outros, sem data, e canceladas/recusadas/pendentes.
 */
export function filtrarMinhasOS(ordens: AgendaOS[], prestadorId: string | null): AgendaOS[] {
  if (!prestadorId) return [];
  return ordens.filter(
    (os) =>
      os.prestador_id === prestadorId &&
      os.data_agendada != null &&
      (STATUS_VISIVEIS as readonly string[]).includes(os.status),
  );
}
